import { Modal, ModalProps } from 'antd';
import StoreScopes, { StoreScopesOwnProps } from './StoreScopes';

export interface StoreScopesModalProps extends Omit<ModalProps, 'onCancel'>, StoreScopesOwnProps {}

function StoreScopesModal(props: StoreScopesModalProps) {
  const {
    value,
    onChange,
    onCancel,
    departmentId,
    platform,
    permId,
    allowEmpty,
    supportWa,
    storeMap,
    storeDataSource,
    showFooterTips,
    singleRegion,
    singlePlatform,
    invalidStoreIds,
    ...otherProps
  } = props;

  return (
    <Modal width={980} footer={false} onCancel={onCancel} {...otherProps}>
      <StoreScopes
        value={value}
        onChange={onChange}
        onCancel={onCancel}
        departmentId={departmentId}
        platform={platform}
        permId={permId}
        allowEmpty={allowEmpty}
        supportWa={supportWa}
        storeMap={storeMap}
        storeDataSource={storeDataSource}
        showFooterTips={showFooterTips}
        singleRegion={singleRegion}
        singlePlatform={singlePlatform}
        invalidStoreIds={invalidStoreIds}
        style={{ margin: '-24px' }}
      />
    </Modal>
  );
}

export default StoreScopesModal;
